import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { defineMessages, useIntl } from 'react-intl';

import { TextStyle } from '../../../DesignSystem/Feedback/TextStyle';
import { Tooltip } from '../../../DesignSystem/Feedback/Tooltip';

dayjs.extend(relativeTime);

export type ChallengeMetaInfoProps = {
  launchDate: string | undefined;
  totalToClaim: number;
};

const messages = defineMessages({
  launched: {
    defaultMessage: `Launched {timeAgo}`,
    id: 'EmKQ2d',
  },
  totalToClaim: {
    defaultMessage: `{totalToClaim} to claim`,
    id: 'Lv9CFh',
  },
});
export const ChallengeMetaInfo = (props: ChallengeMetaInfoProps) => {
  const { launchDate, totalToClaim } = props;
  const { formatMessage } = useIntl();
  return (
    <div className="flex items-center text-gray-8">
      <TextStyle
        variant="xs-regular"
        className="flex items-center justify-center"
      >
        {Boolean(launchDate) && (
          <Tooltip
            tooltipText={dayjs(launchDate).format('MMMM D, YYYY h:mm A')}
          >
            <span>
              {formatMessage(messages.launched, {
                timeAgo: dayjs(launchDate).fromNow(),
              })}
            </span>
          </Tooltip>
        )}
        {Boolean(totalToClaim) && (
          <>
            <TextStyle variant="xs-regular" className="mx-1 text-gray-7">
              •
            </TextStyle>
            <span>
              {formatMessage(messages.totalToClaim, {
                totalToClaim: totalToClaim,
              })}
            </span>
          </>
        )}
      </TextStyle>
    </div>
  );
};
